import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TriviaGamePage from './pages/TriviaGamePage';
import ScenarioGamePage from './pages/ScenarioGamePage';
import ResultsPage from './pages/ResultsPage';
import AboutPage from './pages/AboutPage';
import LeaderboardPage from './pages/LeaderboardPage';
// TODO: Re-enable when favorites API is implemented
// import FavoritesPage from './pages/FavoritesPage';
import ProfilePage from './pages/ProfilePage';
import TimelinePage from './pages/TimelinePage';
import WalkTheStoryPage from './pages/WalkTheStoryPage';
import RanksPage from './pages/RanksPage';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import useAuth0Token from './hooks/useAuth0Token';
import './App.css';
import './mobile-fixes.css';

function App() {
  // Initialize Auth0 token management globally
  useAuth0Token();
  
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/play" element={
          <Layout>
            <TriviaGamePage />
          </Layout>
        } />
        <Route path="/scenario-game" element={
          <Layout>
            <ScenarioGamePage />
          </Layout>
        } />
        <Route path="/walk-the-story" element={
          <Layout>
            <WalkTheStoryPage />
          </Layout>
        } />
        <Route path="/" element={
          <Layout>
            <HomePage />
          </Layout>
        } />
        <Route path="/results" element={
          <Layout>
            <ResultsPage />
          </Layout>
        } />
        <Route path="/leaderboard" element={
          <Layout>
            <LeaderboardPage />
          </Layout>
        } />
        <Route path="/about" element={
          <Layout>
            <AboutPage />
          </Layout>
        } />
        {/* TODO: Re-enable favorites route when API is implemented */}
        {/* <Route path="/favorites" element={
          <Layout>
            <ProtectedRoute component={FavoritesPage} />
          </Layout>
        } /> */}
        <Route path="/profile" element={
          <Layout>
            <ProtectedRoute component={ProfilePage} />
          </Layout>
        } />
        <Route path="/timeline" element={
          <Layout>
            <TimelinePage />
          </Layout>
        } />
        <Route path="/ranks" element={
          <Layout>
            <RanksPage />
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
